<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader
        :page-name="pageName"
        parent-page-name="Photo Images"
        :parent-page-url="`/photos/${this.$route.params.parent_id}/photo-images`"
      />
      <add-edit-form
        v-if="model"
        :returnUrl="`/photos/${this.$route.params.parent_id}/photo-images`"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import PhotoImage from '@/models/PhotoImage'
/* eslint-disable no-undef */
export default {
  name: 'AddPhotoImage',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Photo Image' : 'Add Photo Image'
    },
    categoryOptions () {
      if (this.model.photo_id == this.LIFESTYLE_PHOTO_ID) { // eslint-disable-line
        return [
          {id: 'Back to School', name: 'Back to School'},
          {id: 'Easter', name: 'Easter'},
          {id: 'Evergreen', name: 'Evergreen'},
          {id: 'Graduation', name: 'Graduation'},
          {id: 'Holidays', name: 'Holidays'},
          {id: 'New Year', name: 'New Year'},
          {id: 'Summer Holidays', name: 'Summer Holidays'},
          {id: 'Thanksgiving', name: 'Thanksgiving'},
          {id: 'Valentines Day', name: 'Valentines Day'}
        ]
      } else if (this.model.photo_id == this.RECIPE_PHOTO_ID) { // eslint-disable-line
        return [
          {id: 'Acai Smoothie Bowl', name: 'Acai Smoothie Bowl'},
          {id: 'Apple Berry Popsicles', name: 'Apple Berry Popsicles'},
          {id: 'Apple Blackberry', name: 'Apple Blackberry'},
          {id: 'Apple Cheddar Biscuits', name: 'Apple Cheddar Biscuits'},
          {id: 'Apple Cider Braised Lamb Shanks', name: 'Apple Cider Braised Lamb Shanks'},
          {id: 'Apple Cider Brined Roasted Chicken', name: 'Apple Cider Brined Roasted Chicken'},
          {id: 'Apple Cider Margarita', name: 'Apple Cider Margarita'},
          {id: 'Apple Cider Mimosa', name: 'Apple Cider Mimosa'},
          {id: 'Apple Cranberry Toddy', name: 'Apple Cranberry Toddy'},
          {id: 'Apple Kombucha Mocktail', name: 'Apple Kombucha Mocktail'},
          {id: 'Apple Latkes with Apple Chutney', name: 'Apple Latkes with Apple Chutney'},
          {id: 'Apple Maple Dark n Stormy', name: 'Apple Maple Dark n Stormy'},
          {id: 'Apple Mint Gimlet', name: 'Apple Mint Gimlet'},
          {id: 'Apple Mug Cake', name: 'Apple Mug Cake'},
          {id: 'Apple Orange Martini', name: 'Apple Orange Martini'},
          {id: 'Apple Pastries', name: 'Apple Pastries'},
          {id: 'Apple Pie Cups', name: 'Apple Pie Cups'},
          {id: 'Apple Spice Cake', name: 'Apple Spice Cake'},
          {id: 'Berry Apple Cooler', name: 'Berry Apple Cooler'},
          {id: 'Blu Cheese Crostini', name: 'Blu Cheese Crostini'},
          {id: 'Blue Cheese Burgers', name: 'Blue Cheese Burgers'},
          {id: 'Blush', name: 'Blush'},
          {id: 'Breakfast Smoothie', name: 'Breakfast Smoothie'},
          {id: 'Caramel Apple Mocktail', name: 'Caramel Apple Mocktail'},
          {id: 'Cinroll', name: 'Cinroll'},
          {id: 'Cran Cider Mimosa', name: 'Cran Cider Mimosa'},
          {id: 'Cranberry Bread', name: 'Cranberry Bread'},
          {id: 'Cranberry Gin Fizz', name: 'Cranberry Gin Fizz'},
          {id: 'Cranberry Mimosa', name: 'Cranberry Mimosa'},
          {id: 'Cranberry Sparkling Punch', name: 'Cranberry Sparkling Punch'},
          {id: 'Donut Cake', name: 'Donut Cake'},
          {id: 'Ginger Apple Mocktail', name: 'Ginger Apple Mocktail'},
          {id: 'Gloog', name: 'Gloog'},
          {id: 'Golden Gelt Fizz', name: 'Golden Gelt Fizz'},
          {id: 'Holiday Punch', name: 'Holiday Punch'},
          {id: 'Mum Tart', name: 'Mum Tart'},
          {id: 'Peach Smash', name: 'Peach Smash'},
          {id: 'Pineapple Chicken', name: 'Pineapple Chicken'},
          {id: 'Poison Apple', name: 'Poison Apple'},
          {id: 'Raspberry Smash', name: 'Raspberry Smash'},
          {id: 'Sheet Pan Apple Crisp', name: 'Sheet Pan Apple Crisp'},
          {id: 'Snickerdoodle', name: 'Snickerdoodle'},
          {id: 'Spiked Mulled Apple Cider', name: 'Spiked Mulled Apple Cider'},
          {id: 'Spritzer', name: 'Spritzer'},
          {id: 'VT juice', name: 'VT juice'},
          {id: 'Whiskey Sour', name: 'Whiskey Sour'}
        ]
      }
      return []
    },
    fields () {
      let fields = [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'PSD Format', key: 'PSD', type: 'format' },
        { label: 'PDF Format', key: 'PDF', type: 'format' },
        { label: 'PNG Format', key: 'PNG', type: 'format' },
        { label: 'JPG Format', key: 'JPG', type: 'format' },
        { label: 'EPS Format', key: 'EPS', type: 'format' },
        { label: 'All Formats', key: 'ALL', type: 'format' }
      ]

      if (this.model.photo_id == this.LIFESTYLE_PHOTO_ID || this.model.photo_id == this.RECIPE_PHOTO_ID) { // eslint-disable-line
        fields.push({ label: 'Category', key: 'category', type: 'select', options: this.categoryOptions })
      }

      return fields
    }
  },
  data () {
    return {
      LIFESTYLE_PHOTO_ID: process.env.LIFESTYLE_PHOTO_ID,
      RECIPE_PHOTO_ID: process.env.RECIPE_PHOTO_ID,
      API_BASE_URL: 'photoimage',
      model: null
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new PhotoImage()
      this.model.photo_id = this.$route.params.parent_id
    }
  },
  methods: {
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new PhotoImage(result.photo_image)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Photos/PhotoImages/AddEdit.vue